<edl-authenticated-header>
    <img src="../../../assets/paetep_logo.png" title="PAETEP by Edulink" class="standard-image"/>
    <img src="../../../assets/paetep_logo.png" width="103" height="32.5" title="PAETEP by Edulink" class="mobile-image"/>
    <ul>
        <li><a uiSref="authenticated.messages.my-messages" [uiParams]="messagesParams" >Notifications</a></li>
        <li><a href="https://edulinksolutions.freshdesk.com/support/solutions" target="_blank">Support</a></li>
        <li><a class="logout-button" href="Javascript://" (click)="logout()">Logout</a></li>
    </ul>
    <div class="user-popup">
        <label>Email:</label>
        <p>{{ user?.Email }}</p>

        <a uiSref="authenticated.users.user.edit" [uiParams]="{ userId: user?.UserID }" class="btn btn-secondary" style="margin-top: 10px; width: 100%;">Update Profile</a>
    </div>
</edl-authenticated-header>
